module.exports = __webpack_public_path__ + "img/20210823_122854.5613de49.jpg";